module.exports = __webpack_public_path__ + "img/upliving.7dd619ae.svg";